import { Box, ContentBlock, Heading, Stack } from 'braid-design-system';
import type React from 'react';

import { ErrorIcon } from '../../shared/Icons/ErrorIcon';

type ErrorProps = {
  heading: string;
  children: React.ReactElement;
};

const Error: React.FC<ErrorProps> = ({ heading, children }) => (
  <ContentBlock width="small">
    <Box
      background="surface"
      marginY="xxlarge"
      paddingY={['xxlarge', 'xlarge']}
    >
      <Stack space="large" align="center">
        <ErrorIcon />
        <Stack space="medium" align="center">
          <Heading level="3">{heading}</Heading>
          {children}
        </Stack>
      </Stack>
    </Box>
  </ContentBlock>
);

export { Error };
